import React from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { queryClient } from '@/core/api';
import { RealtimeProvider } from '@/core/realtime';

/**
 * App-wide non-visual providers: TanStack Query, the realtime connection, and
 * toast notifications. Mount high in the tree, inside the Router. The
 * 401-handler is wired by AuthProvider (it needs router + session access).
 *
 * RealtimeProvider sits inside QueryClientProvider because its consumers write
 * into the query cache; it reads auth state straight from the session store, so
 * it needs nothing from AuthProvider (FE-ADR-017).
 */
export const AppProviders: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <RealtimeProvider>{children}</RealtimeProvider>
      <ToastContainer position="top-right" autoClose={5000} newestOnTop />
    </QueryClientProvider>
  );
};
